export default function setStatusText(status: number, isVendor: boolean): string | undefined {
  if (status === 1) return 'Pending Vendor';
  if (status === 2) return 'Requested';
  if (status === 3) return 'Review Vendor';
  if (status === 4) return 'Review Leste';
  if (status === 5) return 'Approved';
  if (status === 6) return isVendor ? 'Contact Leste' : 'Denied';
}
